import styled from "styled-components";

function PopUpCaller(message, color, time) {

    document.getElementById("PopUpWarning").innerHTML = message;
    document.getElementById("PopUpWarning").style.backgroundColor = color;

    setTimeout(() => document.getElementById("PopUpWarning").style.backgroundColor = "rgba(191, 18, 18, 0.0)", time);

}


function PopUpWarning(){

    return(
        <RegisterWarning id={"PopUpWarning"}>...</RegisterWarning>
    )
}

const RegisterWarning = styled.span`
    padding: 10px;
    border-radius: 5px;
    color: white;
    letter-spacing: 1px;
    background-color: rgba(191, 18, 18, 0.0);
    border: solid 0px black;
    transition: .3s ease-in-out;
`

export default PopUpWarning;
export { PopUpCaller };